import { createRoutine } from 'redux-saga-routines';

import {
  GET_FESTIVAL_COUNTRIES,
  GET_FESTIVALS,
  GET_FESTIVAL_YEARS,
  SEARCH_FESTIVALS,
  CLEAR_FESTIVALS_OPTIONS,
  GET_FESTIVALS_PRODUCTIONS,
  GET_FESTIVALS_WITH_PRODUCTIONS,
} from './constants';

export const getFestivalCountriesAction = createRoutine(GET_FESTIVAL_COUNTRIES);
export const getFestivalsAction = createRoutine(GET_FESTIVALS);
export const getFestivalYearsAction = createRoutine(GET_FESTIVAL_YEARS);
export const searchFestivalsAction = createRoutine(SEARCH_FESTIVALS);
export const getFestivalsProductionsAction = createRoutine(GET_FESTIVALS_PRODUCTIONS);
export const getFestivalsWithProductionsAction = createRoutine(GET_FESTIVALS_WITH_PRODUCTIONS);
export const clearFestivalsOptionsAction = createRoutine(CLEAR_FESTIVALS_OPTIONS);
